import React from 'react'
import { Button } from 'src/Common/ui/button'

export default function Acknowledge ({ handleSave, loading }) {
    return (
        <>
            <div className="w-full flex justify-between space-x-4 py-5">
                <div className='text-muted'>
                    {/* Username */}
                </div>
                <Button onClick={handleSave} disabled={loading}>
                    {'Acknowledge'}
                </Button>
            </div>
        </>
    )
}
